<template>
  <div class="col-lg-8 offset-lg-2">
    <card class="card-nav-tabs text-center mb-5" header-classes="card-header-primary">
      <div slot="header">
        <h4 class="mt-1">{{ $t('message.Share your feedback')}}</h4>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12" style="display: flex;justify-content: center;">
              <star-rating v-model="feedback.content.rating" :item-size="30"></star-rating>
            </div>
          </div>
        </div>
        <div class="col-12">
          <textarea class="form-control" :placeholder="$t('message.Describe your experience here')" rows="3" v-model="feedback.content.comment"></textarea>
        </div>
      </div>
      <div slot="footer" class="text-muted">
        <div class="row">
          <div class="col-6">
            <n-button type="primary" round @click.native="$router.push('ambulancedriverhome')" id="submit-btn">
              <h6 class="m-0">{{ $t('message.Go to home')}}</h6>
            </n-button>
          </div>
          <div class="col-6">
            <n-button type="info" :disabled="feedbackSubmitDisabled" round @click.native="submitFeedback()" id="submit-btn">
              <h6 class="m-0">{{ $t('message.Submit')}}</h6>
            </n-button>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
export default {
  name: "feedback",

  data() {
    return {
      feedback: {
        type: "ambulance",
        content: {
          rating: 0,
          comment: "",
        },
      },
    };
  },

  computed: {
    ambulanceRequest() {
      return this.$store.state.ambulanceRequest;
    },
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    feedbackSubmitDisabled() {
      return this.feedback.content.rating == 0;
    },
  },

  methods: {
    async submitFeedback() {
      this.feedback.from = this.user.firstName + " " + this.user.lastName;

      try {
        await this.$store.dispatch("updateAmbulanceFeedback", {
          ambulanceRequestId: this.ambulanceRequest._id,
          feedback: this.feedback,
        });

        swal
          .fire({
            type: "success",
            title: this.$t("message.Thank you for your feedback!"),
            text: this.$t("message.Feedback submitted"),
            timer: 3000,
          })
          .then(() => {
            this.$router.push("ambulancedriverhome");
          });
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
